module.exports = __webpack_public_path__ + "media/images/application/template/button-google-play-323b6526a3aee78ef6a7442f53b2975c.png";